import { CONTENT_SUB_MENU_WIDTH } from "@/config.js";
import { Container, Divider, Grid, ListItemIcon, ListItemText, MenuItem, MenuList } from "@mui/material";
import { Outlet, NavLink as RouterNavLink, useOutletContext } from "react-router-dom";

export default function ProjectSettingLayout() {
    const context = useOutletContext();

    return (
        <Container>
            <Grid
                container
                direction="row"
                justifyContent="space-between"
                alignItems="stretch"
                columnGap={1}
                sx={{ marginTop: 3 }}
            >
                <Grid item xs="auto">
                    <MenuList sx={{ width: CONTENT_SUB_MENU_WIDTH }}>
                        <MenuItem component={RouterNavLink} to="./general">
                            <ListItemText>General</ListItemText>
                        </MenuItem>

                        <MenuItem component={RouterNavLink} to="./info">
                            <ListItemText>Information</ListItemText>
                        </MenuItem>

                        <MenuItem component={RouterNavLink} to="./members" disabled={true}>
                            <ListItemText>Members</ListItemText>
                        </MenuItem>
                    </MenuList>
                </Grid>

                <Grid item xs>
                    <Outlet context={{ ...context }} />
                </Grid>
            </Grid>
        </Container>
    );
}
